import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import React, { useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'
import ReactPaginate from 'react-paginate'
import Navbar from '../../components/navbar/navbar'
import apinode from '../../services/apinode'
//pdfMake.addVirtualFileSystem(pdfFonts);

const RelatorioReservaEstoque = () => {
  const [produtos, setProdutos] = useState([])
  const [currentPage, setCurrentPage] = useState(0) // Mudança para começar do zero
  const [itemsPerPage] = useState(10)

  const handlegetReserva = async () => {
    const response = await apinode.get(
      `estoque/reserva/${localStorage.idconta}`,
    )
    setProdutos(response.data)
  }

  useEffect(() => {
    handlegetReserva()
  }, [])

  // Obter os itens atuais
  const currentItems = produtos.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage,
  )

  // Mudar página
  const handlePageClick = (data) => {
    setCurrentPage(data.selected)
  }

  const generatePdfReport = () => {
    const reportTitle = [
      {
        text: 'Relatório de Reserva de Estoque',
        fontSize: 18,
        bold: true,
        margin: [0, 0, 0, 20], // left, top, right, bottom
      },
    ]

    const productDetails = produtos.map((prod) => {
      return [
        { text: prod.SKU, fontSize: 10 },
        { text: prod.DESCRICAO, fontSize: 10 },
        { text: prod.QTEST.toString(), fontSize: 10 },
        { text: prod.QTRESERV.toString(), fontSize: 10 },
      ]
    })

    const details = [
      {
        table: {
          headerRows: 1,
          widths: ['auto', '*', 'auto', 'auto'],
          body: [
            [
              { text: 'SKU', bold: true },
              { text: 'Descrição', bold: true },
              { text: 'Saldo', bold: true },
              { text: 'Reserva', bold: true },
            ],
            ...productDetails,
          ],
        },
      },
    ]

    const docDefinition = {
      content: [reportTitle, ...details],
      defaultStyle: {
        columnGap: 20,
      },
    }

    pdfMake.createPdf(docDefinition).open()
  }

  return (
    <>
      <Navbar />
      <div className="container mt-page">
        <h2>Relatório de Reserva de Estoque</h2>
        <button
          className="btn btn-primary"
          onClick={generatePdfReport}
        >
          Gerar PDF
        </button>
        <Table
          striped
          bordered
          hover
        >
          <thead>
            <tr>
              <th>#</th>
              <th>Produto</th>
              <th>Saldo</th>
              <th>Reserva</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((item, index) => (
              <tr key={index}>
                <td>{item.SKU}</td>
                <td>{item.DESCRICAO}</td>
                <td>{item.QTEST}</td>
                <td>{item.QTRESERV}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        <ReactPaginate
          previousLabel={'anterior'}
          nextLabel={'próximo'}
          breakLabel={'...'}
          pageCount={Math.ceil(produtos.length / itemsPerPage)}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={'pagination'}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'}
        />
      </div>
    </>
  )
}

export default RelatorioReservaEstoque
